<template>
  <div v-if="isLoading">
    <div class="text-center text-danger screen-center">
      <div class="align-middle spinner-bubble spinner-bubble-danger mr-5"></div>
      <strong>Cargando...</strong>
    </div>
  </div>
  <div v-else>
    <div class="row mb-4">
      <div class="col-sm-12 mb-4">
        <div class="card text-left">
          <div class="card-header">
            <div class="row" style="padding: inherit">
              <div class="col-sm-6 d-flex align-items-center">
                <button
                  class="btn th-custom-color mr-3"
                  type="button"
                  @click="gotToBack()"
                >
                  Regresar
                </button>
                <input type="text" class="form-control"
                  v-model="busqueda"
                  autocomplete="off"
                  placeholder="Buscar"
                  style="max-width: 220px;"
                  @keyup="filtrarBusqueda">
              </div>
              <div class="col-sm-3">
                <strong style="font-size: 20px;">
                    Trabajo Grupal
                  </strong>
              </div>
              <div class="col-sm-3 text-right d-flex align-items-center justify-content-end">
                <label class="switch switch-success mr-3">
                  <input type="checkbox" id="filter"
                    :checked="estado"
                    v-model="estado"
                    @change="getData">
                  <span class="slider"></span>
                  <span>{{ labelActivos }}</span>
                </label>
                <button class="btn w-auto px-3 btn-success">Para Hoy</button>
              </div>
            </div>
          </div>
          <div class="card-body">
              <OrdenItemGrupal
                :id="medico_id"
                :ordenes="ordenesTrabajo"
              />
            <div class="row">
              <div class="col-sm-8">
                </div>
              <div class="col-sm-4">
                <b-pagination
                  v-model="paginaActual"
                  :total-rows="totalFilas"
                  :per-page="porPagina"
                  class="my-0 float-right"
                  @input="getData"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from '@/modules/common/axiosERP';
import { util } from '@/plugins/util';
import OrdenItemGrupal from '../components/OrdenItemGrupal.vue';

export default {
  name: 'index',
  components: {
    OrdenItemGrupal,
  },
  data() {
    return {
      busqueda: null,
      delayTimeout: null,
      estado: true,
      paginaActual: 1,
      totalFilas: 0,
      porPagina: 24,
      ordenesTrabajo: [],
      medico_id: null,
      isLoading: true,
      isFetching: false,
    };
  },
  async created() {
    this.medico_id = this.decrypt(this.$route.params.id);
    await this.getData();
  },
  methods: {
    async getData(silent = false) {
      try {
        if (silent) {
          this.isFetching = true;
        } else {
          this.isLoading = true;
        }
        const params = {
          medico_id: this.medico_id,
          per_page: this.porPagina,
          page: this.paginaActual,
          estado: this.estado,
          filter_key: this.busqueda,
        };
        const response = await axios.get('/clinic/orden_trabajo/grupal', { params });
        this.ordenesTrabajo = response.data.data.data || [];
        this.totalFilas = response.data.data.total || 0;
      } catch (error) {
        util.showNotify(
          error.response?.data?.message || 'Error al cargar las órdenes de trabajo',
          'error',
        );
      } finally {
        this.isLoading = false;
        this.isFetching = false;
      }
    },
    filtrarBusqueda() {
      const DELAY = 600;
      clearTimeout(this.delayTimeout);
      this.delayTimeout = setTimeout(() => this.getData(true), DELAY);
    },
    async regresarIndexDoctor() {
      this.$router.push({ name: 'orden-trabajo-index' });
      await this.getData();
    },
    gotToOrden() {
      this.$router.push({ name: 'orden-trabajo-form1', params: { id: this.encrypt(1) } });
    },
    goToForm1(id) {
      this.$router.push({ name: 'orden-trabajo-medico', params: { id: this.encrypt(id) } });
    },
    gotToBack() {
      this.$router.push({ name: 'orden-trabajo-doctor', params: { id: this.$route.params.id } });
    },
    encrypt(id) {
      return btoa(id);
    },
    decrypt(encodedId) {
      try {
        return atob(encodedId);
      } catch (error) {
        console.error('Error al desencriptar ID:', error);
        return null;
      }
    },
  },
  computed: {
    labelActivos() {
      if (this.estado) {
        return 'Activos';
      }
      return 'Inactivos';
    },
    ...mapState('main', [
      'user',
    ]),
  },
};
</script>

<style scoped>
.custom-top-padding {
  padding-top: 5.53px;
}
</style>
